import SolicitacaoReembolsoEstrangeiro from './componentes/SolicitacaoReembolsoEstrangeiro.vue';
import SolicitacaoReembolsoEstrangeiroLista from './componentes/SolicitacaoReembolsoEstrangeiroLista.vue';
import SolicitacaoReembolsoEstrangeiroForm from './componentes/SolicitacaoReembolsoEstrangeiroForm.vue';
import SolicitacaoReembolsoEstrangeiroRelatorio from './componentes/SolicitacaoReembolsoEstrangeiroRelatorio.vue';

export default {
  path: '/solicitacao-reembolso-estrangeiro',
  component: SolicitacaoReembolsoEstrangeiro,
  meta: { auth: true },
  children: [
    {
      path: '',
      component: SolicitacaoReembolsoEstrangeiroLista,
      name: 'solicitacao-reembolso-estrangeiro',
    },
    {
      path: 'nova',
      component: SolicitacaoReembolsoEstrangeiroForm,
      name: 'solicitacao-reembolso-estrangeiro.nova'
    },
    {
      path: ':id/relatorio',
      component: SolicitacaoReembolsoEstrangeiroRelatorio,
      name: 'solicitacao-reembolso-estrangeiro.relatorio'
    },
    {
      path: ':idCript',
      component: SolicitacaoReembolsoEstrangeiroForm,
      name: 'solicitacao-reembolso-estrangeiro.editar'
    }
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-reembolso-estrangeiro/rotas.js